module.exports = __webpack_public_path__ + "img/Mask Group 182.fe0daf62.svg";